import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataTestRunErrorDisplayComponent } from './data-test-run-error-display.component';

@NgModule({
  declarations: [DataTestRunErrorDisplayComponent],
  imports: [CommonModule],
  exports: [DataTestRunErrorDisplayComponent],
})
export class DataTestRunErrorDisplayModule {}
